import * as React from 'react';
import { TooltipCommonProps } from '../common';

export type InfoIconSize = 'small' | 'medium';

export interface InfoIconProps {
  /** Tooltip content. */
  content: React.ReactNode;

  /** Controls the icon size.
   * @default medium
   */
  size?: InfoIconSize;

  /** A hook for testing purposes. */
  dataHook?: string;

  /** Specifies a CSS class name to be appended to the component's root element.
   * @internal
   */
  className?: string;

  /** Customize <Tooltip/> appearance with its props component.
   * @linkTypeTo components-overlays--tooltip
   * @setTypeName TooltipCommonProps
   */
  tooltipProps?: TooltipCommonProps;

  /** A component to replace default the icon.
   * @internal
   */
  children?: React.ReactNode;

  /** Accessible label for screen readers. */
  ariaLabel?: string;

  'aria-labelledby'?: string;
  'aria-describedby'?: string;
}
